import { useSelector } from 'react-redux';
import { Alert } from 'foundations-components/transitional/components/Alert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { getScopes } from '../../selectors/userSelectors/getScopes';
import { useWhatsAppAccessRevoked } from 'conversations-inbox-lib/whatsapp/public';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const WhatsAppAccessRevokedBanner = () => {
  const scopes = useSelector(getScopes);
  const whatsAppAccessRevoked = useWhatsAppAccessRevoked({
    scopes
  });
  if (whatsAppAccessRevoked) {
    return /*#__PURE__*/_jsx(Alert, {
      type: 'danger',
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-ui.unified-inbox.whatsapp.banner.title"
      }),
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "conversations-inbox-ui.unified-inbox.whatsapp.banner.body_jsx",
        elements: {
          Link
        }
      })
    });
  }
  return null;
};
WhatsAppAccessRevokedBanner.displayName = 'WhatsAppAccessRevokedBanner';
export default WhatsAppAccessRevokedBanner;